import tabslet from '../modules/tabslet';

export default () => {
    tabslet('.about-company__tabs', {
        mouseevent: 'click',
        attribute: 'href',
        animation: true
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/about-company.js